import { render, staticRenderFns } from "./ChooseYourServiceForm.vue?vue&type=template&id=2a656296&scoped=true&"
import script from "./ChooseYourServiceForm.vue?vue&type=script&lang=js&"
export * from "./ChooseYourServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./ChooseYourServiceForm.vue?vue&type=style&index=0&id=2a656296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a656296",
  null
  
)

export default component.exports